module.exports = __webpack_public_path__ + "static/media/add-photo.72f04a94.svg";